module.exports = __webpack_public_path__ + "img/logo.cc416d51.jpg";